import axios from 'axios'
import { getItem, setItem, removeUserData } from '../utils/StorageManager'
import router from '../router/index'
import SERVICE from './servicesUtil'
import config from '@/utils/configUtil'
import Vue from '../main'

let defaultRootUrl = null
// Create an axios instance
const axiosInstance = axios.create({
  // baseURL: async () => await config().VUE_APP_ROOT_API,
  // baseURL: 'https://localhost:5001/services/',
  // timeout: 3000,
  headers: {
    'content-Type': 'application/json',
  },
})

config().then((res) => {
  axiosInstance.defaults.baseURL = res.VUE_APP_ROOT_API
  defaultRootUrl = res.VUE_APP_ROOT_API
})
// request Interceptor
// It lets each request carry a custom token
const whiteListEndpoint = {
  login: '/auth/login',
  registar: '/auth/register',
  recoverPassword: '/auth/recover',
  reset: '/auth/reset-key',
  validate: '/auth/validate',
}

axiosInstance.interceptors.request.use(
  function (config) {
    const accessToken = getItem('accessToken') // store.state.auth.accountId;

    if (accessToken) {
      config.headers.common['Authorization'] = `Bearer ${accessToken}`
    }

    return config
  },

  function (err) {
    return Promise.reject(err)
  },
)

axiosInstance.interceptors.response.use(
  function (config) {
    return config
  },
  function (error) {
    let originalRequest = error.config
    const validationToken = `${SERVICE.AUTH}/token/refresh`

    // Tratamento padrão de alguns erros de negócio
    if (error.response.status == 400) {
      // 160076 - ORGANIZATION_DOES_NOT_HAVE_AN_ACTIVE_PLAN
      if (error.response.data?.errorCode == 160076) {
        Vue.$router.push({ name: 'manage-balance-plans' })
        Vue.$store.commit('auth/SET_SESSION_ORGANIZATION_WITHOUT_ACTIVE_PLAN')
        return
      }
      // 10041 - USER_DOES_NOT_BELONG_TO_ORGANIZATION
      if (error.response.data?.ErrorCode == 10041) {
        let dontHasPlan = Vue.$store.state.auth.session.organization.dontHasPlan
        // Regra pra evitar com que fique em loop quando o plano está indisponível
        if (dontHasPlan) Vue.$router.push({ name: 'notAllowed' })
        else Vue.$router.push({ name: 'notAllowed', params: Vue.$route.params })
        return
      }
      // 160097 - ORGANIZATION_DOES_HAVE_AN_SUSPENDED_PLAN
      /* if (error.response.data?.errorCode == 160097) {
        Vue.$router.push({ name: 'manage-balance-plans', query: { suspendedPlan: true } })
      } */
    }

    // if (error.response.status === 401 && originalRequest.url === validationToken) {
      // removeUserData()
      // router.push('/auth/login')
      // return Promise.reject(error)
    // }

    if (error.response.status === 401 && !originalRequest._retry) {
      // removeUserData()
      // router.push('/auth/login')
      // Vue.$store.dispatch('auth/logout')
      // return Promise.reject(error)
      // originalRequest._retry = true

      // let obj = {
      //   refreshToken: getItem('refreshToken'),
      // }

      // if (!obj.refreshToken) {
      //   removeUserData()
      //   router.push('/auth/login')
      //   return Promise.reject(error)
      // }

      // return axiosInstance
      //   .post(`${validationToken}`, obj)
      //   .then((res) => {
      //     if (res.status === 201 || res.status === 200) {
      //       setItem('accessToken', res.data.data.accessToken)
      //       return new Promise((resolve, reject) => {
      //         axiosInstance(originalRequest)
      //           .then((resp) => {
      //             resolve(resp)
      //           })
      //           .catch((erro) => {
      //             reject(erro)
      //           })
      //       })
      //     }
      //   })
      //   .catch((err) => {
      //     return Promise.reject(err)
      //   })
    }

    // // if (error.response.status >= 500 && error.response.status < 600) {
    // if (error.response.status >= 500 && error.response.status < 502) {
    //   let organizationIdQuery = {}
    //   if (router.currentRoute.params.organizationId) {
    //     organizationIdQuery.organizationId = router.currentRoute.params.organizationId
    //   }
    //   router.push({ name: 'error', query: organizationIdQuery })
    // }

    return Promise.reject(error)
  },
)

export default axiosInstance
